export default __webpack_public_path__ + "static/media/bl_logo.f70326ea.svg";